export function getTextHash(blockIndex: number, textIndex: number) {
	return blockIndex + "_" + textIndex;
}

export function getLinkRefer() {
	let index = 0;
	return () => "link_ref_" + index++;
}

export function hashToInfo(hash = "") {
	if (!hash) {
		return [];
	}
	return hash.split("_").map(val => parseInt(val, 10));
}

export function actionIdToModifierValue(id: string) {
	return id.split("-").pop();
}

export function textColor(color) {
	return `<span class="dxi dxi-format-color-text dhx_richtext__text-color" style="border-color: ${color};"></span>`;
}

export function textSelectColor(color) {
	return `<span class="dxi dxi-format-color-fill dhx_richtext__background-color" style="border-color: ${color};"></span>`;
}

function isObject(target) {
	return target !== null && typeof target === "object" && !(target instanceof Date);
}

export function isEqual(source, target, deep = false) {
	const sourceKeys = Object.keys(source);
	const targetKeys = Object.keys(target);

	if (sourceKeys.length !== targetKeys.length) {
		return false;
	}

	for (const prop of sourceKeys) {
		if (deep && isObject(source[prop]) && isObject(target[prop])) {
			if (!isEqual(source[prop], target[prop], deep)) {
				return false;
			}
		} else if (source[prop] !== target[prop]) {
			return false;
		}
	}

	return true;
}

interface IObject {
	[key: string]: any;
}

export function copyWithout(obj: IObject, forbidden: IObject): IObject {
	const target = {};

	for (const key in obj) {
		if (!forbidden.hasOwnProperty(key)) {
			target[key] = obj[key];
		}
	}
	return target;
}

export function startsWith(str: string, pattern: string) {
	if (str.length < pattern.length) {
		return false;
	}

	for (let i = 0; i < pattern.length; i++) {
		if (str[i] !== pattern[i]) {
			return false;
		}
	}
	return true;
}
